import React from "react";
import { ShortcodeProps } from ".";

const MiljoForurensetGrunn: React.FC<ShortcodeProps> = () => {
  return <span>MiljoForurensetGrunn img</span>;
};

export default MiljoForurensetGrunn;
